export const SIGN_UP_UPDATE_STEP_1 = 1;
export const SIGN_UP_UPDATE_STEP_2 = 2;
export const SIGN_UP_UPDATE_STEP_3 = 3;
